import https from "@/api/api.js";
import router from "../../../router";
/*
 * @Author: 孙福聪
 * @Date: 2019-01-22 14:58:31
 * @Last Modified by: 孙福聪
 * @Last Modified time: 2019-03-28 10:09:32
 */
const state = {
  pattern: "",
  basic: {
    // 案例基本信息页面数据
    CaseBrief: "",
    title: "", // 自定义案例的标题
    type: [], // 自定义案例的类型
    src: "", // 上传的图片
    id: "", // 案例的Id
    stem: "",
    introduce: "" // 案例介绍
  },
  chId: sessionStorage.getItem("chId") || "",
  caseData: {
    // 案例不同阶段的基本信息
    // FORMULATE: {
    //   // 政策制定数据
    //   HallId: "", // 步骤大厅id
    //   tsId: "", // 大厅的场景ID
    //   stageShow: "", // 步骤信息
    //   task: [{}],
    //   taskHome: []
    // },
    // EXECUTE: {
    //   // 政策执行数据
    //   stageShow: "", // 步骤信息
    //   HallId: "", // 步骤大厅id
    //   tsId: "", // 大厅的场景ID
    //   task: [{}],
    //   taskHome: []
    // },
    // ASSESS: {
    //   // 政策评估数据
    //   stageShow: "", // 步骤信息
    //   HallId: "", // 步骤大厅id
    //   tsId: "", // 大厅的场景ID
    //   task: [{}],
    //   taskHome: []
    // },
    // FINALITY: {
    //   // 政策终结数据
    //   stageShow: "", // 步骤信息
    //   tsId: "", // 大厅的场景ID
    //   HallId: "", // 步骤大厅id
    //   task: [{}],
    //   taskHome: []
    // }
  },
  caseValue: []
};
const actions = {};
const mutations = {
  setChId(store, id) {
    const storeData = store;
    sessionStorage.setItem("chId", id);
    storeData.chId = id;
  },
  postSceneControl(store, data) {
    // 保存案例场景下的控件
    const storeData = store;
    console.log(data, storeData.caseData);
    // debugger;
    storeData.caseData[data.index].task[data.setIndex].SceneList[data.sceneIndex].sceneControl =
      data.data;
    //  =
    //   data.data;
  },
  async getCaseData(store, data) {
    try {
      const { data: navList } = await https.getCaseHallNavbarList(data);
      navList.data.forEach(v => {
        store.caseData[v.caseStep] = {
          ...v,
          HallId: "", // 步骤大厅id
          tsId: "", // 大厅的场景ID
          stageShow: "", // 步骤信息
          task: [{}],
          taskHome: []
        };
      });
      store.caseValue = navList.data.sort((a, b) => a.sortNo - b.sortNo).map(v => v.caseStep);
    } catch (error) {
      console.log(error);
    }
  },
  postTaskScene(store, data) {
    // 保存案例场景接口
    const storeData = store;
    storeData.caseData[data.index].task[data.setIndex].SceneList = data.SceneList;
    console.log(
      "保存了场景",
      storeData.caseData[data.index].task[data.setIndex].SceneList,
      data.SceneList,
      data.setIndex,
      data.index
    );
  },
  postTaskTitle(store, data) {
    // 修改单个任务的标题
    const storeData = store;
    storeData.caseData[data.index].task[data.taskIndex].taskName = data.taskName;
  },
  postTask(store, data) {
    // 修改任务列表
    console.log(data, "commit");
    const storeData = store;
    storeData.caseData[data.index].task = data.tasklist || [];
  },
  postcaseHome(store, data) {
    console.log(data, "dattasdasudn");
    // 修改某个步骤的部门基础信息
    const storeData = store;
    console.log(storeData.caseData, "storeData.caseData[data.index]");
    storeData.caseData[data.index].taskHome = data.taskHome || [];
  },
  postCaseContent(store, data) {
    // 修改标题接口
    const storeData = store;
    storeData.basic = data;
  },
  // editControl(store, data) {
  //   // 修改添加场景控件
  //   const storeData = store;
  //   /** data.index -> 步骤 ;  data.setIndex -> 哪个任务 */
  //
  //   /** ↓ 第一次添加场景 直接赋值 */
  //   storeData.caseData[data.index].task[data.setIndex].SceneList = data.data;
  // },
  ResetCaseData(store) {
    console.log("执行");
    const storeData = store;
    storeData.caseData = {
      // 案例不同阶段的基本信息
      // FORMULATE: {
      //   // 政策制定数据
      //   HallId: "", // 步骤大厅id
      //   stageShow: "", // 步骤信息
      //   task: [{}],
      //   taskHome: []
      // },
      // EXECUTE: {
      //   // 政策执行数据
      //   stageShow: "", // 步骤信息
      //   HallId: "", // 步骤大厅id
      //   task: [{}],
      //   taskHome: []
      // },
      // ASSESS: {
      //   // 政策评估数据
      //   stageShow: "", // 步骤信息
      //   HallId: "", // 步骤大厅id
      //   task: [{}],
      //   taskHome: []
      // },
      // FINALITY: {
      //   // 政策终结数据
      //   stageShow: "", // 步骤信息
      //   HallId: "", // 步骤大厅id
      //   task: [{}],
      //   taskHome: []
      // }
    };
  },
  async postHallData(store, data) {
    // 修改某个步骤的大厅ID
    const storeData = store;
    if (!storeData.caseData[data.index]) {
      return;
    }
    storeData.caseData[data.index].HallId = data.id || "";
    storeData.caseData[data.index].stageShow = data.stageShow || "";
  },
  postEDITHomeTSid(store, data) {
    const storeData = store;
    storeData.caseData[data.index].tsId = data.id;
  },
  setCasePattern(store, data) {
    const storeData = store;
    storeData.pattern = data;
    if (!data.includes("policy") && router.app.$route.name !== "login") {
      window.location.href = "/policy/analysis.html";
    }
  }
};
export default {
  state,
  mutations,
  actions
};
